/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetLoginAttemptsByDeviceUuidRequest} from '@cash-web/protos/squareup/cash/janus/api/GetLoginAttemptsByDeviceUuid.pb'
import {GetLoginAttemptsByDeviceUuidResponse} from '@cash-web/protos/squareup/cash/janus/api/GetLoginAttemptsByDeviceUuid.pb'


export const getLoginAttemptsByDeviceUuid = (request: GetLoginAttemptsByDeviceUuidRequest, options?: CashRequestOptions) => post<GetLoginAttemptsByDeviceUuidRequest, GetLoginAttemptsByDeviceUuidResponse>("/2.0/cash/get-login-attempts-by-device-uuid", request, {...options, rejectOnError: true })